import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { UserManagementRoutingModule } from "./user-management-routing.module";
import { UserManagementComponent } from "./user-management/user-management.component";
import { ViewUserComponent } from "./view-user/view-user.component";
import { SharedModule } from "../../shared/shared.module";
import { UserMgmtService } from "./user.service";
import { AddUserComponent } from "./add-user/add-user.component";

import { UserDashboardComponent } from "./user-dashboard/user-dashboard.component";
import { GoogleChartsModule, ScriptLoaderService } from "angular-google-charts";
import { Ng2TelInputModule } from "ng2-tel-input";
import { UserlistComponent } from "./userlist/userlist.component";
import { ViewUserPickDropOrder } from "./view-user-pickdrop-order/view-user-pickdrop-order.component";
import { CouponlistComponent } from "./couponlist/couponlist.component";
@NgModule({
  declarations: [
    UserManagementComponent,
    ViewUserComponent,
    AddUserComponent,
    UserDashboardComponent,
    UserlistComponent,
    ViewUserPickDropOrder,
    CouponlistComponent,
  ],
  imports: [CommonModule, UserManagementRoutingModule, SharedModule, GoogleChartsModule, Ng2TelInputModule],
  providers: [UserMgmtService, ScriptLoaderService],
})
export class UserManagementModule {}
